<template>
<CButtonGroup class="d-block text-center mb-2">
    <CButton :disabled="disabled" :color="isRealUser() ? 'primary' : 'outline-primary'" @click="changeUserIdentifyType(UserIdentifyType.REAL)">شخص حقیقی</CButton>
    <CButton :disabled="disabled" :color="isLegalUser() ? 'primary' : 'outline-primary'" @click="changeUserIdentifyType(UserIdentifyType.LEGAL)">کاربر حقوقی</CButton>
</CButtonGroup>
</template>

<script>
import { UserIdentifyType } from '@/constants'

export default {
    name: 'UserIdentifyType',

    props: {
        value: '',
        disabled: {
            default: false,
            type: Boolean,
        }
    },

    data() {
        return {
            UserIdentifyType,
        }
    },

    methods: {
        changeUserIdentifyType(type) {
            this.$emit('input', type)
        },
        isLegalUser() {
            return this.value === UserIdentifyType.LEGAL
        },
        isRealUser() {
            return this.value === UserIdentifyType.REAL
        },
    }
}
</script>